import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, IdCard } from "lucide-react";
import InnerHero from "../components/InnerHero";

const ieiStudentMembers = [
  {
    slNo: 1,
    name: "Prasanna Ravi Madar",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "6360859654",
    email: "shardamadar96@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0001",
  },
  {
    slNo: 2,
    name: "Raghavendra Raju Bhakappanavar",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "8073625402",
    email: "raghub8792560188@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0002",
  },
  {
    slNo: 3,
    name: "Raghavendra Ramu Tambre",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "8861234355",
    email: "raghutambre6@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0003",
  },
  {
    slNo: 4,
    name: "Rahul Parashuram Balki",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "7892153687",
    email: "rahulbalki4213@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0004",
  },
  {
    slNo: 5,
    name: "Santoshkumar Basavaraj Kotyal",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "8660280441",
    email: "santoshkumarkotyal4@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0005",
  },
  {
    slNo: 6,
    name: "Shashikumar Jagadish Wali",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "6362156451",
    email: "shashiwali6@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0006",
  },
  {
    slNo: 7,
    name: "Shivanand Kallappa Naik",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "7676798934",
    email: "nshivanandnaik01@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0007",
  },
  {
    slNo: 8,
    name: "Sonali Maruti Gouda",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "9019294570",
    email: "sonalimgouda@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0008",
  },
  {
    slNo: 9,
    name: "Sujay Santosh Yatlekar",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "7975358385",
    email: "yatlekarsujay3@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0009",
  },
  {
    slNo: 10,
    name: "Tanmay Jayant Kadrolkar",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "7026571223",
    email: "kdtanmay19@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0010",
  },
  {
    slNo: 11,
    name: "Yatlekar Kunal Narayan",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "8618037177",
    email: "kunalyatlekar17@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0011",
  },
  {
    slNo: 12,
    name: "Vinay Awati",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "8867537419",
    email: "vinyakawati963@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0012",
  },
  {
    slNo: 13,
    name: "Manish S Yelsatti",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "7019372700",
    email: "manish@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0013",
  },
  {
    slNo: 14,
    name: "Shankar R Naik",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "8217728359",
    email: "vijjushankar2@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0014",
  },
  {
    slNo: 15,
    name: "MD Hasir Kallimani",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "9449406867",
    email: "kallimanihasir44@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0015",
  },
  {
    slNo: 16,
    name: "Pratiksha Ashrit",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "9620489054",
    email: "pragatiashrit@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0016",
  },
  {
    slNo: 17,
    name: "Gururaj Hadli",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "7975631760",
    email: "gururajhadli007@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0017",
  },
  {
    slNo: 18,
    name: "Keerthikumar Malemath",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "6366079080",
    email: "keerthikuumarmalemath@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0018",
  },
  {
    slNo: 19,
    name: "Maruti Gopala Badari",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "9353851017",
    email: "marutibadari1@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0019",
  },
  {
    slNo: 20,
    name: "Amruth Kalabbavi",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "8073835150",
    email: "amrutcamrutc789@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0020",
  },
  {
    slNo: 21,
    name: "PraveenKumar Lakamapur",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "9902679821",
    email: "nanjulakamapur@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0021",
  },
  {
    slNo: 22,
    name: "ABHILASH B",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "9880019413",
    email: "gangadharb941@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0022",
  },
  {
    slNo: 23,
    name: "ABHILASH MAHESH MIRAJKAR",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "8217693271",
    email: "mirajkarm1976@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0023",
  },
  {
    slNo: 24,
    name: "ADARSH RAGHAVENDRA PAI",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "6363972427",
    email: "adarshpai12345687@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0024",
  },
  {
    slNo: 25,
    name: "ADITYA ANAND KULKARNI",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "8105706394",
    email: "aditya07kulk@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0025",
  },
  {
    slNo: 26,
    name: "AKSHAY PARASHURAM RACHOTAKAR",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "9380794651",
    email: "akshayrachotakar759@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0026",
  },
  {
    slNo: 27,
    name: "AMULYA V TUDUMA",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "6363386257",
    email: "vjnaykaivalya@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0027",
  },
  {
    slNo: 28,
    name: "ANIRUDH ANIL GAYAS",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "7349219614",
    email: "aniruddhgayas2007@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0028",
  },
  {
    slNo: 29,
    name: "ANIS HUSENSAB CHOURAD",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "6360787528",
    email: "chouradhussain@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0029",
  },
  {
    slNo: 30,
    name: "ANNAPURNA HIREMATH",
    courseCompletionYear: "2030",
    studyYear: "2026",
    branch: "Mech",
    mobile: "9353919466",
    email: "annapurnahiremath2007@gmail.com",
    hqShare: "236",
    membershipNumber: "581329/VDIT/ME/0030",
  },
];

const IEINav = () => (
  <section className="bg-surface-alt/60 border-b border-brand/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex flex-wrap gap-x-6 gap-y-2 text-xs font-sans-ui font-semibold tracking-wider text-brand">
      <Link to="/associations/iei" className="uppercase hover:underline">
        Overview
      </Link>
      <Link to="/associations/iei#achievements" className="uppercase hover:underline">
        Achievements
      </Link>
      <Link to="/associations/iei/activities" className="uppercase hover:underline">
        Activities
      </Link>
      <Link to="/associations/iei/faculty-members" className="uppercase hover:underline">
        Faculty Members
      </Link>
      <Link to="/associations/iei/student-members" className="uppercase hover:underline">
        Student Members
      </Link>
    </div>
  </section>
);

const IEIStudentMembers = () => {
  return (
    <main>
      <InnerHero
        title="IEI Student Members"
        image="https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?w=2400"
        breadcrumbs={[
          { label: "Associations & Innovation Hub", to: "/associations" },
          { label: "IEI", to: "/associations/iei" },
          { label: "Student Members" },
        ]}
      />

      <IEINav />

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <Link
          to="/associations/iei"
          className="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:underline mb-8"
        >
          <ArrowLeft size={16} />
          Back to IEI
        </Link>

        <div className="bg-white border border-brand/15">
          <div className="p-6 md:p-8 border-b border-brand/10">
            <p className="text-xs uppercase tracking-[0.28em] text-brand font-semibold mb-3">
              IEI Student Membership
            </p>
            <h1
              className="text-3xl md:text-5xl text-brand font-semibold leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Student membership details
            </h1>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-[1180px] w-full border-collapse text-sm">
              <thead className="bg-surface-alt/80 text-brand">
                <tr>
                  <th className="border border-brand/20 px-3 py-3 text-left font-semibold">
                    Sl.no
                  </th>
                  <th className="border border-brand/20 px-3 py-3 text-left font-semibold">
                    Name of the student
                  </th>
                  <th className="border border-brand/20 px-3 py-3 text-left font-semibold">
                    Year of course completion
                  </th>
                  <th className="border border-brand/20 px-3 py-3 text-left font-semibold">
                    Year of study
                  </th>
                  <th className="border border-brand/20 px-3 py-3 text-left font-semibold">
                    Branch
                  </th>
                  <th className="border border-brand/20 px-3 py-3 text-left font-semibold">
                    Mobile number
                  </th>
                  <th className="border border-brand/20 px-3 py-3 text-left font-semibold">
                    Email id
                  </th>
                  <th className="border border-brand/20 px-3 py-3 text-left font-semibold">
                    HQ share
                  </th>
                  <th className="border border-brand/20 px-3 py-3 text-left font-semibold">
                    Membership number
                  </th>
                </tr>
              </thead>
              <tbody>
                {ieiStudentMembers.map((member) => (
                  <tr key={member.membershipNumber} className="even:bg-surface-alt/30">
                    <td className="border border-brand/15 px-3 py-3 text-[#2a2a2a]">
                      {member.slNo}
                    </td>
                    <td className="border border-brand/15 px-3 py-3 text-[#2a2a2a] font-semibold">
                      {member.name}
                    </td>
                    <td className="border border-brand/15 px-3 py-3 text-[#2a2a2a]">
                      {member.courseCompletionYear}
                    </td>
                    <td className="border border-brand/15 px-3 py-3 text-[#2a2a2a]">
                      {member.studyYear}
                    </td>
                    <td className="border border-brand/15 px-3 py-3 text-[#2a2a2a]">
                      {member.branch}
                    </td>
                    <td className="border border-brand/15 px-3 py-3 text-[#2a2a2a]">
                      {member.mobile}
                    </td>
                    <td className="border border-brand/15 px-3 py-3 text-[#2a2a2a]">
                      {member.email}
                    </td>
                    <td className="border border-brand/15 px-3 py-3 text-[#2a2a2a]">
                      {member.hqShare}
                    </td>
                    <td className="border border-brand/15 px-3 py-3 text-[#2a2a2a]">
                      <span className="inline-flex items-center gap-1.5">
                        <IdCard size={14} className="text-brand" />
                        {member.membershipNumber}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </main>
  );
};

export default IEIStudentMembers;